import Axios from 'axios';
import { baseURL } from './config';
const qs = require('qs');
import { lang } from '../lang/index';

Axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
Axios.defaults.baseURL = baseURL;

Axios.interceptors.request.use(
  function(config) {
    if (!config.url.match(/lang=/g)) {
      if (!config.url.match(/\?/g)) {
        config.url += '?lang=' + lang;
      } else {
        config.url += '&lang=' + lang;
      }
    }
    config.url += `&platform=2&timestamp=${+new Date()}`;
    config.data = qs.stringify(config.data);
    // 在发送请求之前做些什么
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(function(data) {
  if (data.status == 200 && data.data && !data.data.error) {
    return data.data;
  } else {
    return Promise.reject(data);
  }
});

export default Axios;
